import { useRef } from "react";
import { Col, FormControl, Row } from "react-bootstrap";
import { sendMessage } from "../api/client/websocketclient";
import { Button } from "../common/Button.tsx";

/*
export function notify(sender, message) {
  Notification.requestPermission().then(result => {
    console.info("notifications", result);
    if (result === "granted") {
      const notification = new Notification(sender, {
        body: message,
        icon: "https://placecats.com/100/100",
      });
      console.info(notification);
      notification.onclose = () => console.info("closed");
    }
  });
}
*/

export function NotificationView() {
  const inputRef = useRef();

  const send = () => {
    sendMessage(inputRef.current.value);
    inputRef.current.value = "";
  };

  return (
    <>
      <div>Notification</div>
      <Row>
        <Col>
          <FormControl ref={inputRef} onKeyDown={(e) => e.code === "Enter" && send()} />
        </Col>
        <Col>
          <Button variant="primary" onClick={send}>
            Send
          </Button>
        </Col>
      </Row>
    </>
  );
}
